import type { Column } from '@tanstack/react-table';
import type { tableTexts } from '../texts';
import type { FilterLayout } from '../types';

export function getFilterInputProps(
  column: Column<any, any> | undefined,
  layout: FilterLayout | undefined,
  texts: typeof tableTexts
) {
  if (layout === 'popup') {
    return {
      label: column?.columnDef.meta?.name,
      size: 'medium' as const,
      margin: 'normal' as const,
    };
  } else {
    return {
      placeholder: texts.filter.placeholder,
      size: 'small' as const,
      margin: 'dense' as const,
    };
  }
}
